<section class="container">
    <div class="metricHeading">
        <h4 class="metricName">{{metric?.MetricName | translate}}</h4>
        <span id="metricRecommendation" class="metricValue">{{ recommendationValueText | translate }}</span>
    </div>
    <div class="metricDescription"> 
        <p class="metricInfo">{{metric?.MetricDescription | translate}}</p>
    </div>
</section>